import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormData,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";
import { startUpdateStatus } from "../../actions/students/students";
import { set } from "lodash";

const initialState = {
    data: null,
    notification: null,
    toPay: [],
    selectedCurrency: "",
    promotion: 0,
    isApplyPromotion: false,
    hasConvention: false,
    convention_name: "",
    pay_in: "",
    objectRequest: {},
    openForm: false,
    active: null,
    canDownloadBBVAReference: true,
    educationalCredit: null,
    global_account_status: null,
    hasOrphanInsurance: false,
    serviceInMonth: [],
    simulated: null,
};

export const billingStatus = createSlice({
    name: "billingStatus",
    initialState,
    reducers: {
        setData: (state, action) => {
            state.data = action.payload;
        },
        setToPay: (state, action) => {
            state.toPay = action.payload;
        },
        setOpenForm: (state) => {
            state.openForm = true;
        },
        setCloseForm: (state) => {
            state.openForm = false;
        },
        setToPay: (state, action) => {
            state.toPay = action.payload;
        },
        clean: (state) => {
            state.data = null;
        },
        setSelectedCurrency: (state, action) => {
            state.selectedCurrency = action.payload;
        },
        setPromotion: (state, action) => {
            state.promotion = action.payload;
        },
        setApplyPromotion: (state, action) => {
            state.isApplyPromotion = action.payload;
        },
        setConvention: (state, action) => {
            state.hasConvention = action.payload.hasConvention;
            state.convention_name = action.payload.convention_name;
        },
        setPayIn: (state, action) => {
            state.pay_in = action.payload;
        },
        setObjectRequest: (state, action) => {
            state.objectRequest = action.payload;
        },
        setActive: (state, action) => {
            state.active = action.payload;
        },
        setCanDownloadBBVAReference: (state, action) => {
            state.canDownloadBBVAReference = action.payload;
        },
        setEducationalCredit: (state, action) => {
            state.educationalCredit = action.payload;
        },
        setGlobalAccountStatus: (state, action) => {
            state.global_account_status = action.payload;
        },
        setHasOrphanInsurance: (state, action) => {
            state.hasOrphanInsurance = action.payload;
        },
        setServiceInMonth: (state, action) => {
            state.serviceInMonth = action.payload;
        },
        setSimulated: (state, action) => {
            state.simulated = action.payload;
        },
    },
});

export const {
    setData,
    setToPay,
    setSelectedCurrency,
    setPromotion,
    setApplyPromotion,
    clean,
    setConvention,
    setPayIn,
    setObjectRequest,
    setOpenForm,
    setCloseForm,
    setActive,
    setCanDownloadBBVAReference,
    setGlobalAccountStatus,
    setEducationalCredit,
    setHasOrphanInsurance,
    setServiceInMonth,
    setSimulated,
} = billingStatus.actions;

export default billingStatus.reducer;

// Actions

export const fillStates = (payload, dispatch) => {
    dispatch(setEducationalCredit(payload.educationalCredit));
    dispatch(setApplyPromotion(payload.promotion));
    dispatch(setConvention(payload));
    dispatch(setPayIn(payload.pay_in));
    dispatch(setData(payload.data));
    dispatch(setGlobalAccountStatus(payload.global_account_status));
    dispatch(setHasOrphanInsurance(payload.hasOrphanInsurance));
    dispatch(setServiceInMonth(payload.service_in_months));
    dispatch(setCanDownloadBBVAReference(payload.canDownloadBBVAReference));
};

export const startCalulateAccountStatus = (
    { cycle_id, currency, promotion = null },
    setErrors
) => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());
        const params = new URLSearchParams();
        params.set("cycle_id", cycle_id);
        params.set("currency", currency);
        params.set("promotion", promotion);

        const resp = await Call(
            `students/account-status/calculate`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            if (resp.success.show_notification) {
                Swal.fire({
                    icon: "success",
                    title: "Pago detectado",
                    text: resp.success.notification,
                });
            }

            fillStates(resp.success, dispatch);
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startCalulateAccountStatusByAcademicRecord = (
    {
        academic_record_id,
        cycle_id,
        currency,
        promotion = null,
        updateAcademicRecordStatus = false,
    },
    setErrors = () => {},
    cleanData = false
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("cycle_id", cycle_id);
        params.set("currency", currency);
        params.set("academic_record_id", academic_record_id);

        if (promotion) {
            params.set("promotion", promotion);
        }

        const resp = await Call(
            `operators/students/account-status`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            if (resp.success.show_notification) {
                Swal.fire({
                    icon: "success",
                    title: "Pago detectado",
                    text: resp.success.notification,
                });
            }

            fillStates(resp.success, dispatch);

            //* Actualizar el estatus del alumno
            if (updateAcademicRecordStatus) {
                dispatch(startUpdateStatus(resp.success.student.status));
            }
        } else {
            if (cleanData) {
                dispatch(clean());
            } else {
                errorHandler(resp, setErrors);
            }
        }

        dispatch(stopUILoading());
    };
};

export const NotRequiredBillingMonth = (id, objectRequest) => {
    return async (dispatch) => {
        const { obj, setErrors } = objectRequest;

        const result = await Swal.fire({
            title: "¿Estás seguro de realizar esta acción?",
            icon: "warning",
            text: "No podrás revertir esta acción!",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Si, Eliminar!",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
        });

        if (result.value) {
            dispatch(startUILoading());
            const resp = await Call(
                `students/account-status/not/required/${id}`,
                "POST"
            );

            if (resp.success) {
                Swal.fire({
                    title: "Exito",
                    text: "Se realizó la modificación con éxito",
                    icon: "success",
                });

                dispatch(
                    startCalulateAccountStatusByAcademicRecord(obj, setErrors)
                );
            } else {
                errorHandler(resp, setErrors);
            }
            dispatch(stopUILoading());
        }
    };
};

export const changeBillingStatus = (values, objectRequest, setErrors) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `students/account-status/change-billing-status`,
            "PUT",
            values
        );

        if (resp.success) {
            Swal.fire({
                title: "Exito",
                text: "Se realizó la modificación con éxito",
                icon: "success",
            });

            dispatch(
                startCalulateAccountStatusByAcademicRecord(
                    objectRequest,
                    setErrors
                )
            );
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startBlockByDebt = (values, callback = () => {}, setErrors) => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());

        const resp = await Call(
            `students/account-status/block-by-debt`,
            "PUT",
            values
        );

        const { block_by_debt } = values;

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Exito",
                text: `${block_by_debt ? "Bloqueo" : "Desbloqueo"} realizado`,
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startBlockManyByDebt = (
    lock = [],
    unlock = [],
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `students/account-status/block-many-by-debt`,
            "PUT",
            { lock, unlock }
        );

        const has_lock = !!lock.length;
        const has_unlock = !!unlock.length;

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Exito",
                text: `${has_lock ? "Bloqueos" : ""}${
                    has_lock && has_unlock ? " y " : ""
                }${has_unlock ? "Desbloqueos" : ""} realizados`,
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startChangePaymentToCredit = (
    billing_month_id,
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new FormData();

        params.append("billing_month_id", billing_month_id);

        const resp = await CallWithFormData(
            `students/account-status/change/payment/to/credit`,
            "POST",
            params
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                text: `Ajuste de mensualidad realizado`,
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }
        dispatch(stopUILoading());
    };
};

export const startDownloadAccountStatusSingle = ({
    student_number,
    cycle_id,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await CallWithFormDataFile(
            `operators/students/account-status/generate/account-status/pdf/${student_number}/${cycle_id}`,
            "GET"
        );

        if (resp.error) {
            errorHandler(resp);
        }

        downloadBlob(resp, `${student_number} -  Estado de cuenta`);

        dispatch(stopUILoading());
    };
};

export const startGetSimulated = (values, callback = () => {}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const {
            curriculum_id,
            cycle_id,
            cycle_payment_id = null,
            currency = "MXN",
            is_inscription = true,
        } = values;

        const params = new URLSearchParams();
        params.set("curriculum_id", curriculum_id);
        params.set("cycle_id", cycle_id);
        params.set("currency", currency);
        params.set("is_inscription", is_inscription ? 1 : 0);
        if (cycle_payment_id) {
            params.set("cycle_payment_id", cycle_payment_id);
        }

        const resp = await Call(
            "students/account-status/simulate",
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setSimulated(resp.success));
            callback();
        } else {
            errorHandler(resp);
            setSimulated(null);
        }
        dispatch(stopUILoading());
    };
};

export const startDownloadreferences = () => {
    return async (dispatch) => {};
};

export const clearAccountStatus = () => {
    return async (dispatch) => {
        dispatch(clean());
    };
};
